import { styled } from '../jss-style';
import uploadStyle from './upload';

const useUploadStyle = styled(uploadStyle, 'upload');
export { uploadStyle, useUploadStyle };
export default useUploadStyle;
